import { BabaMainProduct } from './BundleProduct/main';
import { StyledBabaBundle, StyledSubProductsContainer } from './style';
import { BundleProps, ProductData } from 'utils/types';
import { Box } from '@mui/material';
import {
  EProductPriority,
  EProductType,
  ESaleDiscountDisplayType,
} from 'utils/enums';
import { useEffect, useState } from 'react';
import { BabaSaleBadge } from 'components/Badge/Sale/BabaSaleBadge';
import { BabaBundlePrice } from './BundlePrice';
import { babaUtils } from './utils';
import { BabaSubProduct } from './BundleProduct/sub';

export const BabaBundle: React.FC<BundleProps> = ({
  backgroundSrc = 'https://media-staging.appcharge.com/media/66f2b3c0fea2a56ff9086cdb/1728567463394__2bdadf5d-5f08-4839-b07c-d786f46cbbc9',
  price = {
    price: 100,
    currencySymbol: '$',
    isCents: true,
    symbolPosition: 'right',
    fractionalSeparator: '.',
    milSeparator: ',',
    spacing: false,
    currencyCode: 'usd',
    multiplier: 100,
  },
  productList = [
    {
      textFontColorHex: '#ffabff',
      images: {
        product:
          'https://media-staging.appcharge.com/media/66f2b3c0fea2a56ff9086cdb/1728496419194__72a770cd-2bd1-4815-aedf-d1e401424dc8',
      },
      quantity: 100,
      prefix: '',
      suffix: '',
      priority: EProductPriority.MAIN,
      quantityDisplay: '100',
      productType: EProductType.QUANTITY,
      publisherProductId: '',
    },
  ],
  bundleButtonColor,
  bundleButtonTextColor,
  salePercentage = 0,
  salePercentageDisplayType = ESaleDiscountDisplayType.PERCENTAGE,
  bundleRef,
  inMobileMock = false,
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);

  useEffect(() => {
    if (!productList || productList.length === 0) return;

    setMainProduct(productList[0]);

    setSubProducts(productList.slice(1));
  }, [productList]);

  return (
    <StyledBabaBundle
      backgroundSrc={backgroundSrc}
      className={'baba-bundle' + (inMobileMock ? ' bundle--iphone-mock' : '')}
      ref={bundleRef}
    >
      <Box className="container" gap="8px">
        {salePercentage > 0 && (
          <BabaSaleBadge
            salePercentage={salePercentage}
            salePercentageDisplayType={salePercentageDisplayType}
          />
        )}
        {productList.length > 0 ? (
          <Box className="products">
            <BabaMainProduct
              quantityDisplay={mainProduct?.quantityDisplay}
              strokedSaleQuantity={mainProduct?.strokedSaleQuantity}
              image={mainProduct?.images?.product}
              salePercentage={salePercentage}
            />
            <StyledSubProductsContainer>
              {subProducts.map((product, i, sbArray) => (
                <BabaSubProduct
                  key={i}
                  textFontColorHex={product.textFontColorHex}
                  quantityDisplay={product.quantityDisplay}
                  images={product.images}
                  isLastInRow={babaUtils.getIsLastInRow(i, sbArray)}
                />
              ))}
            </StyledSubProductsContainer>
          </Box>
        ) : (
          <Box className="products"></Box>
        )}
        <BabaBundlePrice
          price={price}
          bundleButtonColor={bundleButtonColor}
          bundleButtonTextColor={bundleButtonTextColor}
        />
      </Box>
    </StyledBabaBundle>
  );
};
